import { assetPath } from "@/lib/basePath";

/**
 * Journey top bar — ported from the prototype's <header class="topbar">.
 * Sticky, hairline-bottom, wordmark left; the optional `title` replaces the
 * generic "Assessment" tag next to it (the assessment name + candidate email
 * on the exam screen); the optional `aside` fills the right (timer, Finish).
 * Wordmark rules: 05-atoms.md#wordmark-logo.
 */
export function Topbar({ title, aside }: { title?: React.ReactNode; aside?: React.ReactNode }) {
  return (
    <header className="topbar">
      {/* Plain <img>, not next/image: basePath is not applied to next/image
          loader URLs the way it is to page routes. */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        className="brand-logo"
        src={assetPath("/brand/pluginlive-logo.png")}
        alt="PluginLive"
        width={135}
        height={24}
      />
      <div className="sep" />
      {title ?? <span className="proto-tag">Assessment</span>}
      <div className="spacer" />
      {aside}
    </header>
  );
}
